<script>
  import { ref} from 'vue'
  import { Navigation, Pagination } from 'swiper/modules';
  export default{
  setup(){
        const testimonies =  ref([])
        return { modules: [Navigation, Pagination], testimonies}
  }
}

</script>

<style lang="sass">
    @import ../../common/styles/settings
    @import ../../common/styles/mixins
    @import testimonies
</style>
